<ion-app>
  <ion-badge style="z-index: 99999; opacity: 0.7" *ngIf="!production" color="danger">
    Sandbox (Apenas teste) {{ appVersion }}
  </ion-badge>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
